export const addFilterBikeParameter = (bikeId: string): void => {
    const currentUrl = new URL(window.location.href, window.location.origin);
    currentUrl.searchParams.set('filter_bike_id', bikeId);
    history.replaceState({ path: currentUrl.toString() }, document.title, currentUrl.toString())
}

export const addProductConcreteFilterParameter = (sku: string): void => {
    const url = new URL(window.location.href, window.location.origin);
    const parameter = 'filter_article_number';

    if (url.searchParams.get(parameter)) {
        url.searchParams.delete(parameter);
    }
    url.searchParams.append(parameter, sku);
    history.replaceState({ path: url.toString() }, document.title, url.toString());
}

export const updateRecommendationApiUrl = (recommendationApiUrl: string, richRelevanceFullId: string): string => {
    //TODO: an empty richRelevanceFullId is not normal case, it should be investigated!
    if (!richRelevanceFullId) {
        return recommendationApiUrl;
    }

    const addToCardIdParam = richRelevanceFullId;
    const richRelevanceIdList = addToCardIdParam.split('~');
    const productIdParam = richRelevanceIdList.length > 1 ? richRelevanceIdList[1] : richRelevanceIdList[0];

    const newRecommendationApiUrl =  new URL(recommendationApiUrl, window.location.origin);
    newRecommendationApiUrl.searchParams.set('addToCartId', addToCardIdParam);
    newRecommendationApiUrl.searchParams.set('productId', productIdParam);

    return newRecommendationApiUrl.toString();
}
